import { addDays, startOfDay, isBefore, addMinutes, set } from 'date-fns';

// Delivery is arranged to the half hour, not the minute.
export const DELIVERY_MINUTE_STEP = 30;
// How much warning the rep needs before a delivery can be met.
export const DELIVERY_NOTICE_MINUTES = 60;
/* The working day the slots are drawn from - the hours published on the site.
   Enumerating slots needs them; the old clock did not, which is how it came to
   accept a delivery for two in the morning on a Sunday. */
export const DELIVERY_OPEN_HOUR = 10;
/* The last delivery on offer, not the moment the door shuts: a client who picks
   six is being handed the parts at six, so the grid ends on 18:00 rather than
   half an hour short of it. */
export const DELIVERY_LAST_SLOT_HOUR = 18;
export const DELIVERY_CLOSED_WEEKDAY = 0; // Sunday
// How far ahead the strip runs. Beyond a fortnight is a phone call, not a form.
export const DELIVERY_DAYS_AHEAD = 14;

/* The rep needs an hour's warning to pick and load an order, so the earliest
   slot is a full hour from `now` rounded up to the next half hour: order at
   12:30 and the clock opens at 13:30, order at 12:20 and it opens at 13:30 too.
   Returned as a Date so the same figure builds the grid and guards the confirm,
   rather than the two agreeing by coincidence. */
export const earliestDeliveryFrom = (now) => {
  const from = addMinutes(now, DELIVERY_NOTICE_MINUTES);
  const remainder = from.getMinutes() % DELIVERY_MINUTE_STEP;
  const rounded = remainder === 0 ? from : addMinutes(from, DELIVERY_MINUTE_STEP - remainder);
  return set(rounded, { seconds: 0, milliseconds: 0 });
};

/* Every deliverable moment, grouped by day. Anchored on the earliest slot rather
   than on today, so an order placed at 17:40 - whose hour's notice lands after
   the last slot - does not offer today at all. A day whose slots have all gone by
   drops out of the strip instead of sitting there empty. */
export const buildDeliveryDays = (earliestDelivery) => {
  const from = startOfDay(earliestDelivery);
  const available = [];

  for (let offset = 0; offset < DELIVERY_DAYS_AHEAD; offset += 1) {
    const day = addDays(from, offset);
    if (day.getDay() === DELIVERY_CLOSED_WEEKDAY) continue;

    const slots = [];
    for (let hour = DELIVERY_OPEN_HOUR; hour <= DELIVERY_LAST_SLOT_HOUR; hour += 1) {
      for (let minute = 0; minute < 60; minute += DELIVERY_MINUTE_STEP) {
        // The closing hour carries the slot on the hour, not the half past it.
        if (hour === DELIVERY_LAST_SLOT_HOUR && minute > 0) break;
        const at = set(day, { hours: hour, minutes: minute, seconds: 0, milliseconds: 0 });
        if (!isBefore(at, earliestDelivery)) slots.push(at);
      }
    }

    if (slots.length) available.push({ day, slots });
  }

  return available;
};
